module.exports = __webpack_public_path__ + "img/sub-slash.b9a039c7.svg";